/* eslint-disable i18next/no-literal-string */
import { useCallback } from 'react';

import { Overlay } from '../Overlay/Overlay';
import { Button } from '../Button/Button';
import { LinkButton } from '../LinkButton/LinkButton';
import { logout } from '../../services/schibstedAccount';
import { rawTrackEngagementEvent } from '../../services/tracking/pulse';
import { useIdentity } from '../IdentityProvider/IdentityProvider';

import type { FC } from 'react';

import * as styles from './AccountSharingPopup.module.scss';

interface AccountSharingPopupProps {
  isOpen: boolean;
}

const getRedirectUri = () => {
  const url = new URL(window.location.origin + window.location.pathname);

  // attach `utm_source` so that we can easily track new subscription purchases
  url.searchParams.set('utm_source', 'streamingcontrol');

  return url.toString();
};

export const AccountSharingPopup: FC<AccountSharingPopupProps> = ({
  isOpen,
}) => {
  const { accountUrl } = useIdentity();

  const handleChangePasswordClick = useCallback(() => {
    rawTrackEngagementEvent({
      action: 'Click',
      object: {
        type: 'UIElement',
        id: 'account-sharing-popup:change-password',
      },
    });
  }, []);

  const handleLogoutClick = useCallback(() => {
    rawTrackEngagementEvent({
      action: 'Click',
      intent: 'Logout',
      object: {
        type: 'UIElement',
        id: 'account-sharing-popup:logout',
      },
    });

    logout(getRedirectUri());
  }, []);

  return (
    <Overlay
      type="overlay/popup"
      isOpen={isOpen}
      className={styles.overlay}
      contentClassName={styles.overlayContent}
    >
      <div className={styles.container}>
        <h1 className={styles.header}>Två enheter används redan</h1>
        <div className={styles.description}>
          Du kan maximalt se sändningar från Aftonbladet Plus i två enheter
          samtidigt. Just nu är du redan inloggad på två enheter och kan därför
          inte fortsätta på denna enhet utan åtgärd.
          <br />
          <br />
          Om du misstänker att någon annan använder ditt konto rekommenderar vi
          dig att du byter lösenord, annars logga ut från andra enheter.
        </div>
        <div className={styles.buttons}>
          <LinkButton
            url={accountUrl}
            onClick={handleChangePasswordClick}
            size="large"
            variant="contained"
            isActiveBrandColor
          >
            Ändra lösenord
          </LinkButton>
          <Button size="large" variant="contained" onClick={handleLogoutClick}>
            Logga ut
          </Button>
        </div>
      </div>
    </Overlay>
  );
};
